/**
 * A v4 UUID for a set's client id.
 *
 * `crypto.randomUUID` only exists in a secure context, and the app is reached
 * over plain HTTP on the tailnet, where calling it throws before the set is
 * even sent. `getRandomValues` has no such restriction, so build it by hand
 * when the shortcut is missing.
 */
export function newClientId(): string {
  if (typeof crypto.randomUUID === "function") return crypto.randomUUID();
  const bytes = crypto.getRandomValues(new Uint8Array(16));
  bytes[6] = (bytes[6]! & 0x0f) | 0x40;
  bytes[8] = (bytes[8]! & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, "0")).join("");
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}
